import { Button, Stack, Typography, useTheme } from "@mui/material";
import { Check, Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const R = Resources.Portfolio.List.DocumentUpload.Success;

type Props = {
	name: string;
	folder: string | null;
	linkedItemTitle: string | null;
	onViewDocuments: () => void;
	onUploadAnother: () => void;
	onBack: () => void;
};

export const DocumentUploadSuccess: FC<Props> = ({
	name,
	folder,
	linkedItemTitle,
	onViewDocuments,
	onUploadAnother,
	onBack,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			minHeight="100%"
			px={2.4}
			py={4}
		>
			<IconBox bg={palette.green[100]} size={64} shape="circle" mb={1.6}>
				<Check size={32} color={palette.green[600]} />
			</IconBox>
			<Typography variant="h2" mb={0.8}>
				{t(R.title)}
			</Typography>
			<Typography variant="body2" mb={0.4}>
				{folder ? t(R.savedInFolder, { name, folder }) : t(R.saved, { name })}
			</Typography>
			{linkedItemTitle && (
				<Typography variant="hint">
					{t(R.linkedWith, { item: linkedItemTitle })}
				</Typography>
			)}

			<Stack width="100%" gap={1.2} mt={3.2}>
				<Button variant="primary" fullWidth onClick={onViewDocuments}>
					{t(R.viewInDocuments)}
				</Button>
				<Button
					variant="secondary"
					fullWidth
					startIcon={<Plus size={16} />}
					onClick={onUploadAnother}
				>
					{t(R.uploadAnother)}
				</Button>
				<Button
					variant="textLink"
					fullWidth
					onClick={onBack}
					sx={{ mt: spacingTokens.xs }}
				>
					{t(R.back)}
				</Button>
			</Stack>
		</Stack>
	);
};
